import { IconButton, Link, useTheme } from "@mui/material";

import {
  BCPClipboardList,
  BCPFill,
  BCPHandshake,
  BCPList,
  BCPRankingStar,
  BCPCalendarDay,
  BCPRotateLeft,
  BCPUserGroup,
  BCPIdBadge,
  BCPUsers,
  BCPTicket,
  BCPUsersViewfinder,
  BCPCodeBranch,
  BCPBrackets,
  BCPSliders,
  BCPLockKeyhole,
  BCPCircleInfo,
  BCPLinkSimple,
  BCPCertificate
} from "../../../components/icons/bcp/BCPIcons";
import DeckIcon from "../../../components/icons/DeckIcon";

import {
  findGetParameter,
  getData,
  sortedPlayersArray
} from "../../../components/utilities/UtilityFunctions";

import { postNotification } from "../../../components/utilities/Notifications";
import moment from "moment";
import "moment-timezone";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import {
  getLocalStorage,
  removeLocalStorage
} from "../../../components/layout/cookies/CookieFunctions";
import { handlePagingAll } from "../../../components/api/APIUtilities";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";
const IS_WARMACHINE = getEnvironmentVariable("COMPANY_FLAG") === "wm";

export async function getEvent(eventId, authContext, options) {
  const fetchEvent = async () => {
    if (!eventId) return null;

    var returnObj;
    try {
      var expands = [
        "location",
        "gameStore",
        "owner",
        "gameSystem",
        "scorecard",
        "teamScorecard"
      ];
      if (options?.ticketing) {
        expands.push("ticketing");
      }
      if (options?.role) {
        expands.push("role");
      }
      if (options?.following) {
        expands.push("following");
      }
      if (options?.player) {
        expands.push("player");
      }
      returnObj = await getData(`/events/${eventId}`, {
        queryStringParameters: {
          "expand[]": expands
        }
      });

      if (options?.overview) {
        returnObj.overview = await fetchOverview(options);
      }

      if (options?.photo && returnObj.photoFileId) {
        returnObj.photoFile = await fetchFile(returnObj.photoFileId);
      }

      if (options?.circuits || options?.league) {
        returnObj.circuits = await fetchLeagues(
          returnObj?.gameSystemId || returnObj?.gameSystem?.id
        );
      }
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  const fetchFile = async (fileId) => {
    if (!fileId) return;

    var returnObj;
    try {
      returnObj = await getData(`/files/${fileId}`, {
        queryStringParameters: {}
      });
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  const fetchOverview = async (options) => {
    if (!eventId) return null;

    let returnObj;
    let playerObj;
    let teamPlayerObj;
    try {
      returnObj = await getData(`/events/${eventId}/overview`);

      if (options?.player) {
        try {
          playerObj = await getData(`/events/${eventId}/currentPlayer`);
        } catch {
          //  Will 404 if player is not registered to event
        }

        if (returnObj?.format?.teamEvent) {
          try {
            teamPlayerObj = await getData(
              `/events/${eventId}/currentTeamPlayer`
            );
          } catch {
            //  Will 404 if team is not registered to event
          }
        }
      }

      if (playerObj?.id) {
        returnObj.player = playerObj;
      }

      if (teamPlayerObj?.id) {
        returnObj.teamPlayer = teamPlayerObj;
      }
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  const fetchLeagues = async (gSystemId) => {
    let queryParams = {
      public: true,
      active: true,
      sortKey: "name",
      gameSystemId: gSystemId
    };

    try {
      const leagueData = await handlePagingAll("/leagues", queryParams);

      if (leagueData) {
        leagueData.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });
        return leagueData;
      } else return [];
    } catch (err) {
      return [];
    }
  };

  var apiGetData = await fetchEvent();

  if (!apiGetData?.displayOverall) apiGetData.displayOverall = false;
  if (apiGetData.externalUrl) {
    if (!/^https?:\/\//i.test(apiGetData.externalUrl)) {
      apiGetData.externalUrl = "http://" + apiGetData.externalUrl;
    }
  }

  if (apiGetData.eventDate) {
    var eventDate = moment(apiGetData.eventDate);
    if (apiGetData.hasOwnProperty("location")) {
      if (apiGetData.location.hasOwnProperty("timeZone")) {
        eventDate = eventDate.tz(apiGetData.location.timeZone);
      }
    }
    apiGetData.eventDateDisplay = eventDate;
  }
  if (apiGetData.eventEndDate) {
    var eventEndDate = moment(apiGetData.eventEndDate);
    if (apiGetData.hasOwnProperty("location")) {
      if (apiGetData.location.hasOwnProperty("timeZone")) {
        eventEndDate = eventEndDate.tz(apiGetData.location.timeZone);
      }
    }
    apiGetData.eventEndDateDisplay = eventEndDate;
  }

  if (apiGetData.pricingDict) {
    var keys = Object.keys(apiGetData.pricingDict);
    if (keys?.length > 0) {
      apiGetData.pricingInfo = {
        currency: keys[0],
        amount: (apiGetData.pricingDict[keys[0]] / 100).toFixed(2)
      };
    }
  }

  apiGetData.eventMetrics = [
    { key: "numWins", name: "Wins" },
    { key: "battlePoints", name: "Battle Points" }
  ];
  if (!apiGetData.placingMetrics) {
    apiGetData.placingMetrics = [
      {
        isOn: true,
        key: "numWins",
        name: "Wins",
        negative: false
      },
      {
        isOn: true,
        key: "battlePoints",
        name: "Battle Points",
        negative: false
      }
    ];
  }
  var x = 0;
  for (var i = 0; i < apiGetData.placingMetrics?.length; i++) {
    if (apiGetData.placingMetrics[i].isOn) {
      apiGetData.eventMetrics[x] = apiGetData.placingMetrics[i];
      x++;
    }
  }

  return apiGetData;
}

export const officialTemplateType = {
  label: "Official",
  sort: 1
};
export const otherTemplateType = {
  label: "Other",
  sort: 999999
};

export async function getEventTemplates(gameSystemId, options) {
  if (!gameSystemId) return null;

  let apiData; // To store the raw API response
  let eventTemplates = []; // Initialize with an empty array

  let queryStringParameters = {
    gameSystemId: gameSystemId,
    limit: 100
  };

  if (options?.limit) {
    queryStringParameters.limit = options.limit;
  }

  if (options?.nextKey) {
    queryStringParameters.nextKey = options.nextKey;
  }

  try {
    apiData = await getData(`/gamesystemtemplates`, queryStringParameters);
    if (apiData && Array.isArray(apiData.data)) {
      for (let template of apiData.data) {
        if (!template.templateType) {
          template.templateType = otherTemplateType;
        }
      }
      eventTemplates = apiData.data;
    }
  } catch (err) {
    console.error("Error in getEventTemplates:", err);
  } finally {
    return eventTemplates;
  }
}

export function BuildRecordJSX({ player }) {
  const theme = useTheme();
  if (player?.games?.length || player?.pod_games?.length) {
    return (
      <>
        {player?.games.map((game, index) => {
          return (
            <>
              {index > 0 && <span> / </span>}
              <span
                style={{
                  color:
                    game.gameResult === 2
                      ? theme?.palette?.win?.main
                      : game.gameResult === 1
                        ? theme?.palette?.draw?.main
                        : theme?.palette?.loss?.main
                }}
              >
                {IS_WARMACHINE
                  ? game.gameResult === 2
                    ? "W"
                    : game.gameResult === 1
                      ? "D"
                      : "L"
                  : game.gamePoints !== undefined
                    ? game.gamePoints
                    : game.gameResult}
              </span>
            </>
          );
        })}
        {player?.pod_games &&
          player.pod_games.map((game, index) => {
            return (
              <>
                {(index > 0 || player?.games?.length > 0) && <span> / </span>}
                <span
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color:
                      game.gameResult === 2
                        ? theme?.palette?.win?.main
                        : game.gameResult === 1
                          ? theme?.palette?.draw?.main
                          : theme?.palette?.loss?.main
                  }}
                >
                  {game.gamePoints !== undefined
                    ? game.gamePoints
                    : game.gameResult}
                </span>
              </>
            );
          })}
      </>
    );
  }
  return <></>;
}

export function handlePlayersChange(event, currentPlayers, options) {
  currentPlayers = sortedPlayersArray(
    currentPlayers,
    event?.eventMetrics,
    options?.showOverall
  );
  const counters = {
    registered: 0,
    checkedin: 0,
    active: 0,
    waiting: 0
  };

  const newPlayerDict = {};
  const newPlayerArray = [];
  let rank = 0;

  if (currentPlayers?.length) {
    currentPlayers.forEach((player, index) => {
      if (player?.isPod) {
        newPlayerArray.push(player);
        return;
      }
      rank++;
      if (!player?.loadedPlacing && player?.placing) {
        player.loadedPlacing = player.placing;
      }
      player.placing = options?.showOverall
        ? rank
        : player?.loadedPlacing || rank;
      if (!player?.paymentPending) counters.registered++;
      if (player?.checkedIn && !player?.paymentPending) counters.checkedin++;
      if (player?.checkedIn && !player?.dropped && !player?.paymentPending)
        counters.active++;
      player.recordJSX = <></>;
      const podTemp =
        event.bracketPairings && player.podNum === 1 && player.pod_resultRecord
          ? "pod_"
          : "";
      if (player?.[podTemp + "games"]) {
        player.recordJSX = <BuildRecordJSX player={player} />;
      }

      newPlayerDict[player.id] = player;
      if (!player?.paymentPending) newPlayerArray.push(player);
    });
  }

  if (!options?.isPlacings) {
    newPlayerArray.sort((a, b) => {
      const nameA =
        event?.teamEvent || event?.doublesEvent
          ? a?.name?.toLowerCase()
          : userDisplayName(
              a?.firstName || a?.user?.firstName,
              a?.lastName || a?.user?.lastName
            ).toLowerCase();
      const nameB =
        event?.teamEvent || event?.doublesEvent
          ? b?.name?.toLowerCase()
          : userDisplayName(
              b?.firstName || b?.user?.firstName,
              b?.lastName || b?.user?.lastName
            ).toLowerCase();
      if (nameA > nameB) return 1;
      if (nameA < nameB) return -1;
      return 0;
    });
  }

  return {
    newPlayerDict: newPlayerDict,
    newPlayerArray: newPlayerArray,
    counters: counters
  };
}

export function userDisplayName(firstName, lastName) {
  return `${firstName || ""} ${lastName || ""}`.trim();
}

export function getArmyListColor(player) {
  return player &&
    (player.armyListObjectId || player.armyListId || player.listId)
    ? "success"
    : "error";
}

export function armyListActions(player, event, organize) {
  if (!player || !event) return {};
  return {
    onClick:
      event.hideLists && !organize
        ? (e) => {
            e.stopPropagation();
            postNotification(
              "warning",
              `This Event has ${
                event?.gameSystem?.listLabel || "List"
              }s set to hidden`
            );
          }
        : !player.armyListObjectId && !player.armyListId && !player.listId
          ? (e) => {
              e.stopPropagation();
              postNotification(
                "warning",
                `${userDisplayName(
                  player?.firstName || player?.user?.firstName,
                  player?.lastName || player?.user?.lastName
                )} has not submitted their ${
                  event?.gameSystem?.listLabel || "List"
                }`
              );
            }
          : (e) => {
              e.stopPropagation();
            },
    href: !(!event.hideLists || organize)
      ? null
      : player.listUrl !== undefined && player.listUrl !== ""
        ? player.listUrl
        : player.armyListSolforge
          ? `${getEnvironmentVariable("HEADER_SOLFORGE_URL") || ""}/fused/${
              player.armyListSolforge.id
            }`
          : player.armyListObjectId || player.armyListId || player.listId
            ? `/list/${player.armyListObjectId || player.armyListId || player.listId}`
            : null,
    target:
      (!event.hideLists || organize) &&
      (player.armyListObjectId || player.armyListId || player.listId)
        ? `_blank`
        : null
  };
}

export function ArmyListIconButton(props) {
  const { organize, player, event, dense, sx } = props;
  const actions = armyListActions(player, event, organize);
  return (
    <IconButton
      {...actions}
      sx={{
        bgcolor: dense
          ? null
          : event.hideLists && !organize
            ? "text.disabled"
            : `${getArmyListColor(player)}.main`,
        color: dense
          ? event.hideLists && !organize
            ? "text.disabled"
            : `${getArmyListColor(player)}.main`
          : event.hideLists && !organize
            ? "background.secondary"
            : `${getArmyListColor(player)}.contrastText`,
        "&:hover": {
          bgcolor: dense
            ? null
            : event.hideLists && !organize
              ? "text.disabled"
              : `${getArmyListColor(player)}.dark`,
          color: dense ? `${getArmyListColor(player)}.dark` : null
        },

        ...sx
      }}
    >
      {getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
        <DeckIcon color={getArmyListColor(player)} />
      ) : (
        <BCPClipboardList />
      )}
    </IconButton>
  );
}

export function ArmyListLink(props) {
  const { organize, player, event } = props;
  const actions = armyListActions(player, event, organize);
  return (
    <Link
      {...actions}
      underline="none"
      color={
        player?.armyListObjectId || player?.armyListId || player?.listId
          ? "link"
          : "text.secondary"
      }
    >
      {player?.armyListObjectId || player?.armyListId || player?.listId
        ? "View List"
        : "No List"}
    </Link>
  );
}

export function getMenuItems(
  event,
  authContext,
  setResetModalOpen,
  setShareModalOpen,
  appRoute,
  t = null
) {
  if (!event?.id) {
    return null;
  }

  const embed = appRoute || findGetParameter("embed") === "true";

  var middleItems = [
    {
      title: event?.name
    },
    {
      divider: true
    },
    {
      title: t ? t("eventActions") : "Event Actions"
    },
    {
      href: `/organize/event/${event.id}?active_tab=roster${
        embed ? "&embed=true" : ""
      }`,
      icon: BCPUserGroup,
      title: t ? t("playersAndLists") : "Players & Lists"
    },
    {
      href: `/organize/event/${event.id}?active_tab=pairings${
        embed ? "&embed=true" : ""
      }`,
      icon: BCPHandshake,
      title: t ? t("pairings") : "Pairings"
    },

    event?.topCut ||
    event?.pairingStyle === "single elimination" ||
    event?.pairingStyle === "double elimination"
      ? {
          href: `/organize/event/${event.id}?active_tab=brackets${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPBrackets,
          title: t ? t("brackets") : "Brackets"
        }
      : null,

    {
      href: `/organize/event/${event.id}?active_tab=placings${
        embed ? "&embed=true" : ""
      }`,
      icon: BCPRankingStar,
      title: t ? t("leaderboard") : "Leaderboard"
    },
    event?.gameSystem?.supportSoftScores
      ? {
          href: `/organize/event/${event.id}?active_tab=soft-scores${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPFill,
          title: t ? t("softHobbyScores") : "Soft/Hobby Scores"
        }
      : null,
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      event?.gameSystemId
    ) ||
    authContext?.authState?.identity?.isJudge ||
    event?.userRole?.permissions?.judgeReport !== undefined
      ? {
          href: `/organize/event/${event.id}?active_tab=judge-report${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPIdBadge,
          title: t ? t("judgeReport") : "Judge Report"
        }
      : null,
    { divider: true, sx: { mt: 1, mb: 1 } },
    {
      title: t ? t("eventSettings") : "Event Settings"
    },
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      event?.gameSystemId
    ) ||
    event?.userRole?.permissions?.eventDetails !== undefined
      ? {
          href: `/organize/event/${event.id}?active_tab=info${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPCircleInfo,
          title: t ? t("info") : "Info"
        }
      : null,
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      event?.gameSystemId
    ) ||
    event?.userRole?.permissions?.eventDetails !== undefined
      ? {
          href: `/organize/event/${event.id}?active_tab=details${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPCalendarDay,
          title: t ? t("eventDetails") : "Event Details"
        }
      : null,
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      event?.gameSystemId
    ) ||
    event?.userRole?.permissions?.eventDetails !== undefined
      ? {
          href: `/organize/event/${event.id}?active_tab=config${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPSliders,
          title: t ? t("gameConfiguration") : "Game Configuration"
        }
      : null,
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      event?.gameSystemId
    ) ||
    event?.userRole?.permissions?.eventDetails !== undefined
      ? {
          href: `/organize/event/${event.id}?active_tab=registration${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPTicket,
          title: t ? t("registrationAndTickets") : "Registration & Tickets"
        }
      : null,
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      event?.gameSystemId
    ) ||
    (event?.userRole?.permissions?.eventDetails !== undefined &&
      event?.circuits?.length > 0)
      ? {
          href: `/organize/event/${event.id}?active_tab=circuits${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPCertificate,
          title: t ? t("circuits") : "Circuits"
        }
      : null,
    authContext?.authState?.identity?.isAdmin === true ||
    authContext?.authState?.identity?.adminGameSystems?.includes(
      event?.gameSystemId
    ) ||
    NO_SUBSCRIPTIONS !== undefined ||
    (event?.owner?.subscribed &&
      event?.userRole?.permissions?.eventUsers !== undefined)
      ? {
          href: `/organize/event/${event.id}?active_tab=users${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPUserGroup,
          title: t ? t("eventUsers") : "Event Users"
        }
      : null,
    event?.privateEvent
      ? {
          href: `/organize/event/${event.id}?active_tab=access-codes${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPLockKeyhole,
          title: t ? t("accessCodes") : "Access Codes"
        }
      : null,
    { divider: true, sx: { mt: 1, mb: 1 } },
    {
      onClick: () => {
        setResetModalOpen(true);
      },
      icon: BCPRotateLeft,
      title: t ? t("reset") : "Reset"
    },
    {
      onClick: () => {
        setShareModalOpen(true);
      },
      icon: BCPLinkSimple,
      title: t ? t("shareAndEmbed") : "Share & Embed"
    },
    {
      href: `/event/${event.id}?active_tab=overview`,
      icon: BCPUsersViewfinder,
      title: t ? t("publicView") : "Public View"
    }
  ];
  return middleItems;
}

export function getPairingMenuItems(pairing, appRoute, t = null) {
  if (!pairing?.event?.id) {
    return null;
  }

  const embed = appRoute || findGetParameter("embed") === "true";

  var middleItems = [
    {
      title: pairing.event?.name
    },
    pairing?.teamPairingId
      ? {
          href: `/game/teampairing/${pairing.teamPairingId}${
            embed ? "?embed=true" : ""
          }`,
          icon: BCPUsers,
          title: t ? t("teamPairing") : "Team Pairing"
        }
      : null,
    {
      href: `/${pairing.event.isTO ? "organize/" : ""}event/${
        pairing.event.id
      }?active_tab=roster${embed ? "&embed=true" : ""}`,
      icon: BCPList,
      title: t ? t("roster") : "Roster"
    },
    {
      href: `/${pairing.event.isTO ? "organize/" : ""}event/${
        pairing.event.id
      }?active_tab=pairings${embed ? "&embed=true" : ""}`,
      icon: BCPHandshake,
      title: t ? t("pairings") : "Pairings"
    },

    pairing?.event?.pairingStyle === "single elimination" ||
    pairing?.event?.pairingStyle === "double elimination"
      ? {
          href: `/organize/event/${pairing.event.id}?active_tab=brackets${
            embed ? "&embed=true" : ""
          }`,
          icon: BCPCodeBranch,
          title: t ? t("brackets") : "Brackets"
        }
      : null,

    {
      href: `/${pairing.event.isTO ? "organize/" : ""}event/${
        pairing.event.id
      }?active_tab=placings${embed ? "&embed=true" : ""}`,
      icon: BCPRankingStar,
      title: t ? t("placings") : "Placings"
    }
  ];

  return middleItems;
}

export function getSoftScoreMenuItems(event, appRoute, t = null) {
  if (!event?.id) {
    return null;
  }

  const embed = appRoute || findGetParameter("embed") === "true";

  var middleItems = [
    {
      title: event?.name
    },
    {
      href: `/${event.isTO ? "organize/" : ""}event/${
        event.id
      }?active_tab=roster${embed ? "&embed=true" : ""}`,
      icon: BCPList,
      title: t ? t("roster") : "Roster"
    }
  ];
  if (event.numberOfRounds > 0) {
    middleItems.push({
      href: `/${event.isTO ? "organize/" : ""}event/${
        event.id
      }?active_tab=pairings${embed ? "&embed=true" : ""}`,
      icon: BCPHandshake,
      title: t ? t("pairings") : "Pairings"
    });
  }

  if (
    event?.pairingStyle === "single elimination" ||
    event?.pairingStyle === "double elimination"
  ) {
    middleItems.push({
      href: `/organize/event/${event.id}?active_tab=brackets${
        embed ? "&embed=true" : ""
      }`,
      icon: BCPCodeBranch,
      title: "Brackets"
    });
  }

  middleItems.push({
    href: `/${event.isTO ? "organize/" : ""}event/${
      event.id
    }?active_tab=placings${embed ? "&embed=true" : ""}`,
    icon: BCPRankingStar,
    title: "Placings"
  });

  return middleItems;
}

export function refreshRoster() {
  removeLocalStorage("roster");
  removeLocalStorage("rosterData");
  window.location.reload();
}

export function refreshPlacings() {
  removeLocalStorage("placings");
  removeLocalStorage("placingsData");
  window.location.reload();
}

export function getRosterLocalVars() {
  const locRoster = getLocalStorage("roster")
    ? JSON.parse(getLocalStorage("roster"))
    : null;
  const locRosterMetaData = getLocalStorage("rosterData")
    ? JSON.parse(getLocalStorage("rosterData"))
    : null;

  return {
    locRoster,
    locRosterMetaData
  };
}

export function getPlacingsLocalVars() {
  const locPlacings = getLocalStorage("placings")
    ? JSON.parse(getLocalStorage("placings"))
    : null;
  const locPlacingsData = getLocalStorage("placingsData")
    ? JSON.parse(getLocalStorage("placingsData"))
    : null;

  return {
    locPlacings,
    locPlacingsData
  };
}

export function refreshPairings(reload = true) {
  removeLocalStorage("pairings");
  removeLocalStorage("pairingsData");
  if (reload) {
    window.location.reload();
  }
}

export function getPairingsLocalVars() {
  const locPairings = getLocalStorage("pairings")
    ? JSON.parse(getLocalStorage("pairings"))
    : null;
  const locPairingsData = getLocalStorage("pairingsData")
    ? JSON.parse(getLocalStorage("pairingsData"))
    : null;

  return {
    locPairings,
    locPairingsData
  };
}

export function markdownToPlainText(str) {
  // remove headers
  str = str.replace(/#+\s+(.*)/g, "$1");

  // remove images
  str = str.replace(/!\[.*\]\(.*\)/g, "");

  // remove links
  str = str.replace(/\[(.*?)\]\((.*?)\)/g, "");

  // remove bold text
  str = str.replace(/\*\*(.*)\*\*/g, "$1");

  // remove italicized text
  str = str.replace(/\*(.*)\*/g, "$1");

  // remove inline code
  str = str.replace(/`(.*)`/g, "$1");

  // remove horizontal lines
  str = str.replace(/\n---\n/g, "");

  // remove blockquotes
  str = str.replace(/^>\s+/gm, "");

  // remove strikethrough text
  str = str.replace(/~~(.*?)~~/g, "$1");

  // remove backticks
  str = str.replace(/`/g, "");

  return str.trim();
}

export function getWebsocketUrl() {
  const WEBSOCKET_URL = getEnvironmentVariable("WEBSOCKET_URL")
    ? getEnvironmentVariable("WEBSOCKET_URL")
    : getEnvironmentVariable("AMPLIFY_BRANCH") === "testing" ||
        getEnvironmentVariable("AMPLIFY_BRANCH") ===
          "testing-organizations-overhaul"
      ? "wss://test-ws.bestcoastpairings.com"
      : getEnvironmentVariable("AMPLIFY_BRANCH") === "bcp-staging"
        ? "wss://newstaging-ws.bestcoastpairings.com"
        : "wss://newdevelop-ws.bestcoastpairings.com/";

  return WEBSOCKET_URL;
}
